/* Imports */
import React, { useState } from "react"
import { Flexbox, Burger } from "fajny-react"

import ComponentPage from "../../components/ComponentPage"
import DemoItem from "../../components/DemoItem"

import commonProps from "../../data/common-props"

const BurgerPage = () => {
    const [isPrimaryOpen, setIsPrimaryOpen] = useState(false)
    const [isSecondaryOpen, setIsSecondaryOpen] = useState(false)
    const [isSuccessOpen, setIsSuccessOpen] = useState(false)
    const [isDangerOpen, setIsDangerOpen] = useState(false)
    const [isWarningOpen, setIsWarningOpen] = useState(false)
    const [isWhiteOpen, setIsWhiteOpen] = useState(false)

    const item = {
        content: (
            <Flexbox gap="s">
                <Burger color="primary" isOpen={isPrimaryOpen} onClick={() => setIsPrimaryOpen(!isPrimaryOpen)} />
                <Burger
                    color="secondary"
                    isOpen={isSecondaryOpen}
                    onClick={() => setIsSecondaryOpen(!isSecondaryOpen)}
                />
                <Burger color="success" isOpen={isSuccessOpen} onClick={() => setIsSuccessOpen(!isSuccessOpen)} />
                <Burger color="danger" isOpen={isDangerOpen} onClick={() => setIsDangerOpen(!isDangerOpen)} />
                <Burger color="warning" isOpen={isWarningOpen} onClick={() => setIsWarningOpen(!isWarningOpen)} />
                <Burger color="white" isOpen={isWhiteOpen} onClick={() => setIsWhiteOpen(!isWhiteOpen)} />
            </Flexbox>
        ),
        code: '<Burger color="primary" isOpen={isPrimaryOpen} onClick={() => setIsPrimaryOpen(!isPrimaryOpen)} />\n<Burger color="secondary" isOpen={isSecondaryOpen} onClick={() => setIsSecondaryOpen(!isSecondaryOpen)} />\n<Burger color="success" isOpen={isSuccessOpen} onClick={() => setIsSuccessOpen(!isSuccessOpen)} />\n<Burger color="danger" isOpen={isDangerOpen} onClick={() => setIsDangerOpen(!isDangerOpen)} />\n<Burger color="warning" isOpen={isWarningOpen} onClick={() => setIsWarningOpen(!isWarningOpen)} />\n<Burger color="white" isOpen={isWhiteOpen} onClick={() => setIsWhiteOpen(!isWhiteOpen)} />',
    }

    const propsItems = [
        {
            name: "isOpen",
            type: "Boolean",
            required: "Yes",
        },
        {
            name: "color",
            type: "String",
            example: "white",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            name: "ariaLabel",
            type: "String",
            example: "Open / Close menu",
            default: "Open / Close burger",
            required: "No",
        },
    ]

    return (
        <ComponentPage propsItems={propsItems}>
            <DemoItem demo={item} />
        </ComponentPage>
    )
}

export default BurgerPage
